import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

import Loader from "./Loader";

const RequestLoaderContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  bottom: 5px;
  right: 5px;
  background-color: transparent;
  zindex: 999999;
  @media (orientation: Portrait) {
    width: 50px;
    height: 50px;
    bottom: 50px;
    right: 0px;
  }
`;

export default connect((state) => {
  return {
    loading: state.api.requesting || state.specsheet.savingPhoto,
  };
}, {})(({ loading }) => {
  return loading ? (
    <RequestLoaderContainer>
      <Loader />
    </RequestLoaderContainer>
  ) : (
    <></>
  );
});
